module.exports = __webpack_public_path__ + "img/package_history.5544eb96.png";